import DialogModifyPwd from './dialog-modify-pwd';

export default DialogModifyPwd;